import { authenticationRoutes } from '@/modules/authentication/router';
import { userTypesRoutes } from '@/modules/user-type/router';
import { systemRoutes } from '@/modules/system/router';
import { functionalityRoutes } from '@/modules/functionality/router';
import { profileRoutes } from '@/modules/profile/router';
import { userRoutes } from '@/modules/user/router';
import { authenticatedHomeRoutes } from '@/modules/home/router';
import { neovehicleRoutes } from './modules/neovehicle/router';
import { neopvcRoutes } from '@/modules/neopvc/router';

import HomePage from '@/pages/home.page.vue';
import AboutPage from '@/pages/about.page.vue';
import Vue from 'vue';
import Router from 'vue-router';
import AuthService from '@/services/AuthService';

const auth = new AuthService();

Vue.use(Router);

declare const process: any;

export const MAIN_ROUTES = Object.freeze({
  HOME: 'home-route',
  ABOUT: 'about-route',
});

const router = new Router({
  mode: 'history',
  routes: [
    ...authenticatedHomeRoutes,
    ...authenticationRoutes,
    ...userTypesRoutes,
    ...systemRoutes,
    ...functionalityRoutes,
    ...profileRoutes,
    ...userRoutes,
    ...neovehicleRoutes,
    ...neopvcRoutes,
    {
      path: process.env.BASE_URL,
      component: () => import('@/layout/default.layout.vue'),
      children: [
        { path: '/about', name: MAIN_ROUTES.ABOUT, component: AboutPage },
        {
          path: '',
          name: MAIN_ROUTES.HOME,
          component: HomePage,
          // redirect: { name: DEALER_ACCESS_ROUTES.DEALER_ACCESS },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    auth.getUser().then((user) => {
      if (user === null) {
        window.location.href = '/';
      }
      next();
    });
  }
  next();
});

export default router;
